import "./FormLogin.scss";
import { useRef, useState, useEffect } from "react";
import { Button } from 'react-bootstrap';
import InputFieldSet from "../../../repository/inputFieldSet/InputFieldSet";
import { languageElements } from "./FormLogin-languageElements";
import LanguageElementsHandler from "../../../repository/languageElementsHandler/LanguageElementsHandler";
import useMain from "../../../common/MainContext";

export default function LoginForm(props) {
  const { login, language } = useMain();
  const languageElementsHandler = new LanguageElementsHandler(
    languageElements,
    language
  );

  const [formWasValidated, setFormWasValidated] = useState(false);

  const [errors, setErrors] = useState({
    login: "",
    pass: "",
  });

  function showMessageShortly(codeOfMessage, typeOfAlert) {
    setFormAlertText(languageElementsHandler.get(codeOfMessage));
    setFormAlertType(typeOfAlert);
    setTimeout(() => {
      setFormAlertText("");
      setFormAlertType("");
    }, 5000);
  }

  function clearAllErrors() {
    setErrors({
      login: "",
      pass: "",
    });
  }

  const [fieldValues, setFieldValues] = useState({
    login: "",
    pass: "",
  });

  const references = {
    login: useRef(),
    pass: useRef(),
  };

  const [formAlertText, setFormAlertText] = useState("");
  const [formAlertType, setFormAlertType] = useState("");

  const validators = {
    login: {
      required: isNotEmpty,
    },
    pass: {
      required: isNotEmpty,
    },
  };

  const errorTypes = {
    required: languageElementsHandler.get(`validation-required`),
  };

  function isNotEmpty(value) {
    return value !== "";
  }

  useEffect(() => {
    clearAllErrors();
  }, [language]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (isFormValid()) {
      const body = {
        email: fieldValues.login,
        password: fieldValues.pass,
      };

      fetch(`${process.env.REACT_APP_API_BASE_URL}/token`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((data) => {
          if (data.status !== 200) {
            throw new Error("result-nok");
          }
          return data.json();
        })
        .then((jsonData) => {
          login(jsonData.token);
        })
        .catch((error) => {
          showMessageShortly(
            error.message === "result-nok"
              ? error.message
              : "result-no-response",
            "danger"
          );
        });
    }
  }

  function loginAsGuest() {
    login('GUEST');
  }

  function isFormValid() {
    let isFormValid = true;
    for (const fieldName of Object.keys(fieldValues)) {
      const isFieldValid = validateField(fieldName);
      if (!isFieldValid) {
        isFormValid = false;
      }
    }
    return isFormValid;
  }

  function handleInputBlur(e) {
    const fieldName = e.target.name;
    setErrors((previousErrors) => ({
      ...previousErrors,
      [fieldName]: "",
    }));

    validateField(fieldName);
  }

  function handleInputChange(e) {
    const value = e.target.value;
    const fieldName = e.target.name;
    setFieldValues({
      ...fieldValues,
      [fieldName]: value,
    });
    setErrors((previousErrors) => ({
      ...previousErrors,
      [fieldName]: "",
    }));
  }

  function validateField(fieldName) {
    const value = fieldValues[fieldName];
    let isValid = true;
    setErrors((previousErrors) => ({
      ...previousErrors,
      [fieldName]: "",
    }));
    references[fieldName].current.setCustomValidity("");

    if (validators[fieldName] !== undefined) {
      for (const [validationType, validatorFn] of Object.entries(
        validators[fieldName]
      )) {
        if (isValid) {
          isValid = validatorFn(value);
          if (!isValid) {
            const errorText = errorTypes[validationType];
            setErrors((previousErrors) => {
              return {
                ...previousErrors,
                [fieldName]: errorText,
              };
            });
            references[fieldName].current.setCustomValidity(errorText);
          }
        }
      }
    }
    return isValid;
  }

  return (
    <div className="login-form fullpage">
      {formAlertText && (
        <div className={`alert mt-3 alert-${formAlertType}`} role="alert">
          {formAlertText}
        </div>
      )}
      <form
        noValidate={true}
        className={`data-and-buttons fullpage needs-validation ${formWasValidated ? "was-validated" : ""
          }`}
      >
        <div className="field-area">
          <InputFieldSet
            reference={references["login"]}
            name="login"
            labelText={languageElementsHandler.get(`field-login`)}
            type="text"
            errors={errors}
            fieldValues={fieldValues}
            handleInputBlur={handleInputBlur}
            handleInputChange={handleInputChange}
            required={true}
          />
          <InputFieldSet
            reference={references["pass"]}
            name="pass"
            labelText={languageElementsHandler.get(`field-pass`)}
            type="password"
            errors={errors}
            fieldValues={fieldValues}
            handleInputBlur={handleInputBlur}
            handleInputChange={handleInputChange}
            required={true}
          />
        </div>
        <div className="button-area">
          <Button variant='success' onClick={handleSubmit}>
            {languageElementsHandler.get(`btn-login`)}
          </Button>
          <Button variant='success' onClick={loginAsGuest}>
            {languageElementsHandler.get(`btn-loginAsGuest`)}
          </Button>
        </div>
      </form>
    </div>
  );
}
